module.exports = __webpack_public_path__ + "static/img/top-78-logo.18276a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/top-78-logo.png
// module id = yjaX
// module chunks = 0